"use client";

import React from "react";
import GenericLazyLoader from "@/components/common/generic-lazy-loader";
import { ContactFormSection } from "@/types/dto/destinations-page/destination-page-types";

interface ContactFormSectionProps {
  contactFormSection: ContactFormSection;
}


const LazyLoadContactFormSection = ({ contactFormSection }: ContactFormSectionProps) => 

    <GenericLazyLoader
      importComponent={() => import("@/components/forms/contact-form-section/contact-form-section")}
      componentProps={{ contactFormSection }}
      debugName="Contact Form Section"
      threshold={0.1}
      rootMargin="200px 0px"
    />;

export default LazyLoadContactFormSection;